import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { AppProviders } from "./app/providers/AppProviders.js";
import { router } from "./app/router.js";
import {
  addPerformanceSink,
  consoleSink,
  startWebVitalsCollection,
} from "./shared/perf/index.js";
import { registerServiceWorker } from "./shared/sw/register.js";
// PR-0 (visual-realignment Strategy A): import the H5 source-of-truth stylesheet
// before React's own globals.css. Every visual decision should derive from
// origin/main:styles.css; React-only tokens / utility classes in globals.css
// only layer on top. Components are progressively migrated off
// `*.module.css` to consume H5's global class names directly.
import "../../h5/styles.css";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </React.StrictMode>,
);

// Phase 4.6 — register the service worker in production. The helper is a
// no-op in dev / SSR / tests; see src/shared/sw/register.ts.
registerServiceWorker();

// Phase 4.7 — Web Vitals + custom-metric collection. In dev, log to the
// console; production sites should call addPerformanceSink(beaconSink(...))
// once a backend endpoint is provisioned.
if (import.meta.env.DEV) {
  addPerformanceSink(consoleSink);
}
void startWebVitalsCollection();
